<template>
  <router-view />
</template>

<script>
export default {
  name: "stock",
};
</script>